module.exports = __webpack_public_path__ + "img/isfj-selected.bf94f9f4.png";